/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespComplementaryItemsGrid_user$ref = any;
type PdpRespSimilarItemsGrid_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsFooter_user$ref: FragmentReference;
export type PdpRespSimilarItemsFooter_user = {|
  +$fragmentRefs: PdpRespComplementaryItemsGrid_user$ref & PdpRespSimilarItemsGrid_user$ref,
  +$refType: PdpRespSimilarItemsFooter_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsFooter_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespComplementaryItemsGrid_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '150c38bc572db4f377eda689032617d6';
module.exports = node;
